export const VOLUME_UNITS = { L: 'L', M3: 'm3' } as const;
export type VolumeUnit = (typeof VOLUME_UNITS)[keyof typeof VOLUME_UNITS];

export const WEIGHT_UNITS = { KG: 'kg', LB: 'lb' } as const;
export type WeightUnit = (typeof WEIGHT_UNITS)[keyof typeof WEIGHT_UNITS];

export interface Measurement<U extends string> {
  unit: U;
  value: number;
}
